import axios from 'axios';
import { SERVER_URL } from './Constants';

const getAxiosInstance = () => {
    const language = localStorage.getItem('translationLanguage') ? localStorage.getItem('translationLanguage') : 'en';
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : '';

    let axiosInstance = axios.create({
        baseURL: SERVER_URL,
        headers: {
            'Accept-Language': `LANGUAGE${language}`,
            ...(token && { 'Authorization': `TOKEN${token}` })
        }
    })

    return axiosInstance;
}

export default getAxiosInstance;


// WEBPACK FOOTER //
// ./src/utils/AxiosUtils.js